module.exports = {

    'OLD_PASSWORD': "Antiga clau d'acces",
    'OLD_PASSWORD_REQUIRED': "Es requereix l'antiga clau d'acces",
    'OLD_PASSWORD_NOT': "L'antiga clau d'acces no és correcta",
    'NEW_PASSWORD': "Nova clau d'acces",
    'NEW_PASSWORD_REQUIRED': "Es requereix la nova clau d'acces",
    'CONFIRM_PASSWORD': "Confirmar clau d'acces",
    'CONFIRM_PASSWORD_REQUIRED': "Cal una confirmació de clau d'acces",
    'CONFIRM_PASSWORD_SAME': "Les claus d'acces no coincideixen",

    // NG-Admin
    'BACK': 'Tornar',
    'DELETE': 'Eliminar',
    'CREATE': 'Crear',
    'EDIT': 'Edita',
    'EXPORT' : 'Exporta',
    'ADD_FILTER' : 'Afegir filtre',
    'SEE_RELATED': "Veure tot relacionat {{ entityName }}",
    'LIST': 'llista',
    'SHOW': 'Mostrar',
    'SAVE': 'Desar',
    'N_SELECTED': '{{ length }} Seleccionat',
    'ARE_YOU_SURE': 'Estàs segur?',
    'YES': 'Si',
    'NO': 'No',
    'FILTER_VALUES': 'Valors de filtre',
    'CLOSE': 'Tancar',
    'CLEAR': 'Netejar',
    'CURRENT': 'Corrent',
    'REMOVE': 'Treure',
    'ADD_NEW': 'Afegeix nou {{ name }}',
    'BROWSE': 'Busqueda',
    'N_COMPLETE': '{{ progress }}% Complet',
    'CREATE_NEW': 'Crear nou',
    'SUBMIT': 'Enviar',
    'SAVE_CHANGES': 'Desa els canvis',
    'BATCH_DELETE_SUCCESS': 'Elements eliminats correctament',
    'DELETE_SUCCESS': 'Element eliminat correctament',
    'ERROR_MESSAGE': 'Oops! Hi ha hagut un error(code: {{ status }})',
    'INVALID_FORM': 'Forma invalida',
    'CREATION_SUCCESS': 'Element creat correctament',
    'EDITION_SUCCESS': 'Canvis guardats correctament',
    'ACTIONS': 'Accions',
    'PAGINATION': '<strong>{{ begin }}</strong> - <strong>{{ end }}</strong> of <strong>{{ total }}</strong>',
    'NO_PAGINATION': 'Cap record va ser trobat',
    'PREVIOUS': '« Anterior',
    'NEXT': 'Següent »',
    'DETAIL': 'Detall',
    'STATE_CHANGE_ERROR': 'Error de canvi d\'estat: {{ message }}',
    'NOT_FOUND': 'No funciona',
    'NOT_FOUND_DETAILS': 'La pàgina que cerca no es troba. Tome un descans abans d\'intentar de nou.',

    //lang
    'SPANISH' : "Castellà",
    'ENGLISH' : "Anglès",
    'CATALAN' : "Català",

    //Menu
    'ORDERS' : "Ordres",
    'ACCOUNT' : "Compte",
    'PURCHASES' : "Compres",
    'DOWNLOADS' : "Descàrregues",
    'USERS' : "Usuaris",
    'USER_LIST' : "Llista de pacients",
    'PRENSCRIBER_LIST' : "Llista de professionals",
    'COMPANY_LIST' : "Llista d'empreses",
    'PRESCRIBER_TYPES' : "Tipus de prescriptor",
    'PRODUCTS' : "Productes",
    'SUBSCRIPTIONS': "Subscripcions",
    'LICENCES': "Llicències",
    'LICENCES_TEXT': "Totes les llicències estan subjectes a un manteniment anual i la signatura d'un contracte",
    'GAMES': "Jocs",
    'CONFIG': "Configuració",
    'VARIABLES': "Variables",
    'ABILITIES': "Habilitats",
    'LOGOUT': "Tancar sessió",
    'PRESNCRIPTORS': 'Prescriptors',
    'PROFESSIONAL_MANUAL': "Manual del professional",
    'PROFESSIONAL_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/manual_profesional_cast.pdf',
    'USER_MANUAL': "Guia d'usuari",
    'USER_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/guia_usuari_cat.pdf',
    'VIDEOS_TUTORIAL': 'videos tutorials',

    // Login
    'REGISTER': "Registre",
    'LOGIN': "Inicia sessió",
    'USERNAME_OR_EMAIL': "Nom d'usuari",
    'RECOVERY_PASSWORD': "Recuperar clau d'acces",
    'USERNAME_EMAIL_RECOVERY': "Es requereix un nom d'usuari.",
    'PASSWORD_REQUIRED': "Es requereix clau d'acces.",
    'LETS_GO': "¡Som-hi!",
    'PASSWORD': "Contrasenya",
    'ERROR_USSER_PASSWORD_INCORRECT': "Nom d'usuari o clau d'acces incorrecta",
    'LOGIN_REGISTER': "Registra't",
    'OR': "o",
    'ERROR_LINK_EXPIRED': "El enllaç per recuperar la clau d'acces ha expirat, per favor sol·liciteu un altre",

    //Recovery
    'SIGN_IN_AGAIN': "Iniciar sessió de nou",
    'INTERNAL_ERROR': "Error intern",
    'Invalid username or email': "Nom d'usuari no vàlid",
    'Password request alerady requested': "Sol·licitud de clau d'acces ja ha estat sol·licitada",
    'SEND_EMAIL_REQUEST_SUCCESS': "T'hem enviat un email amb els passos per restablir la clau d'acces.",


    //Register
    'USER': "Usuari",
    'USERNAME': "Nom d'usuari",
    'USERNAME_REASON': "El nom d'usuari es farà servir perquè et puguem identificar a la pantalla de login",
    'PRESCRIBER': "Prescriptor",
    'USERNAME_REQUIRED': "Es requereix nom d'usuari",
    'ACCEPT_TERMS_SERVICE': "Estic d'acord amb els termes del servei",
    'YOU_MUST_ACCEPT_TERMS_SERVICE_BEFORE_PROCEED': "Ha d'acceptar els termes de servei abans de continuar",
    'USERNAME_ALREADY_TAKEN': "El nom d'usuari ja aquesta fet servir",
    'CREATED_CHECK_YOUR_EMAIL': 'El seu compte ha estat creat amb èxit, comprova el seu correu electrònic.',
    'MALFORMET_DATA': 'S\'ha Produït errors en el formulari',
    'PASSWORD_SHORT': "La clau d'acces és massa curta",

    //Account
    'YOU_ARE': "Tipus d'usuari",
    'YOUR_LICENCES': "Les teves llicències",
    'MANAGE_LICENCES': "Administrar llicències",
    'YOUR_SUBSCRIPTIONS': "Les teves subscripcions",
    'NEED_MORE_LICENCES': "¿Necessita més llicències?",
    'PURCHASE_LICENCES': "Llicències de compra",
    'PURCHASE_SUBSCRIPTIONS': "Comprar Subscripcions",
    'ADD_LICENCE': "Afegir llicència",
    'RECHARGE_SUBSCRIPTIONS': "Subscripcions de recàrrega",
    'ACTIVE_UNUSED': "Actiu / no utilitzat",
    'MANAGE_SUSCRIPTIONS': "Administrar Subscripcions",
    'ADD_SUSCRIPTIONS': "Afegir subscripcions",
    'ORDERS_INVOICES': "Comandes i factures",
    'YOUR_LAST_PAYMENT': "El seu últim pagament, de",
    'WAS_MADE_ON': "Va ser fet a",
    'SHOW_ORDERS': "Mostra comandes & factures",
    'Company' : 'Empresa',
    'Prescriber' : 'Prescriptor',
    'Patient' : 'Pacient',

    //calendary
    'january': "gener",
    'february': "febrer",
    'march': "març",
    'april': "abril",
    'mayo': "maig",
    'june': "juny",
    'july': "juliol",
    'august': "agost",
    'september': "setembre",
    'october': "octubre",
    'november': "novembre",
    'december': "desembre",

    //Licences
    'LICENCE': "Llicència",
    'ASSIGNED_TO': "Assignat a",
    'EXPIRATION_AT': "Expira el",
    'MAC': "Mac",
    'REASSIGN_THIS_LICENCE': "Reassignar aquesta llicència",
    'CHOOSE_AN_USER': "Tria un usuari",
    'SELECT_AN_USER': "Selecciona un usuari",
    'REVOKE_MAC_LICENCE': "Revocar aquesta llicència de Mac",
    'REASSIGN': "Reassignar",
    'REMOVE_YOUR_LICENCE_LINK': "Li agradaria eliminar el seu enllaç de llicència?",
    'REMOVE_YOUR_LICENCE_LINK_TEXT': "En eliminar l'enllaç de llicència podria utilitzar aquesta llicència en un altre equip. de cerca:' + 'Recordeu que el nou equip estarà vinculat a aquesta llicència",
    'LUCKY_DAY': "Bon dia",
    'SUCCESS_REMOVE_LICENCE': "El seu enllaç de llicència s'ha eliminat",
    'MANUAL_INVOICE': 'Factura manual',
    'NO_LICENCE': 'Necessita una llicència activa',
    'NO_LICENCE_BUY': 'Si us plau compri una llicència',

    //Purchases
    'SELECT_PRODUCT': "Seleccionar producte",
    'PROMOTIONAL_CODE': "Té un codi promocional?",
    'CODE_DOES_NOT_PROMOTION': "El codi no té cap promoció",
    'TOTAL_ITEMS': "Articles totals",
    'TAXES': "Impostos",
    'AMOUNT_PAYABLE': "Total a pagar",
    'USE_MY_ACCOUNT_INFORMATION_INVOICE': "Utilitza la informació del meu compte per a la factura",
    'USE_OTHER_INFORMATION_INVOICE': "Utilitza una altra informació per a la factura",
    'NAME': "Nom",
    'NAME_REQUIRED': "Es requereix el nom",
    'SURNAME': "Cognom",
    'SURNAME_REQUIRED': "El cognom és obligatori",
    'COMPANY': "Empresa",
    'CIF/NIF': "CIF/NIF",
    'CIF_NIF_REQUIRED': "CIF o NIF és necessari",
    'ADDRESS': "Direcció",
    'CITY': "Ciutat",
    'STATE': "Província",
    'COUNTRY': "País",
    'COMPANY_REQUIRED': "L'empresa és requerida",
    'POSTAL_CODE': "Codi postal",
    'YOU_SUPPLY_POSTAL_CODE': "Ha de proporcionar un codi postal",
    'THAT_DOESNT_LOOK_LIKE_VALID_PC': "Això no sembla un codi postal vàlid",
    'BUY_LICENCE': "Comprar",
    'BUY_SUSCRIPTIONS': "Comprar",
    'ORDER': "Ordre",
    'YOU_MUST_MAKE_BANK_TRANSFER': "Ha de fer una transferència bancària al",
    'WITH_THE_CONCEPT': "Amb el concepte",
    'PAY_WITH_PAYPAL': "Pagar amb PayPal",
    'PAY_WITH_CREDIT_CARD': "Pagar amb targeta de crèdit",
    'PAY_WITH_WIRE_TRANSFER': "Pagar amb transferència bancària",
    'SELECT_METHOD': "Selecciona un mètode",
    'YOU_DONT_HAVE_PERMISSION_AREA': "No tens permís en aquesta àrea",
    'UNIT_PRICE': "La unitat surt a",
    'YOUR_PENDING_REMOVED':"La seva compra pendent s'ha eliminat",
    'CONFIRM_REMOVE_PURCHASE_PENDING':"Vols eliminar aquesta compra pendent?",
    'CANCEL':"Cancel",
    'REMOVE!':"Eliminar!",
    'BUY_SUCCESS': "La seva comanda ha estat tramitat correctament.",
    'CIF_NIF_ALREADY_EXISTS': "El cif/nif/nie ja existeix",
    'CIF_NIF_INVALID' : "El cif/nif/nie no és vàlid",
    'PHONE_REQUIRED': "El telèfon és obligatori",
    'ADDRESS_REQUIRED': "L'adreça és obligatòria",
    'CITY_REQUIRED': "La ciutat és obligatória",

    //ERRORS
    'PLEASE_INSERT_NUMERIC_VAL':"Please insert a numeric value!",
    'NOT_ENOUGH_SUBS':"No té suficients subscripcions",
    'USER_HAS_NOT_SUBS':"Aquest usuari no té subscripció",
    'UNAUTORITHED':"Sense autorització",
    'INVALID_DETAILS_IN_FORM':"Alguns valors no són vàlids, vegeu els detalls del formulari",


    //thanks
    'THANK_YOU': "Gràcies",
    'THE_PURCHASE_WAS_MADE_CORRECTLY': "La compra es va realitzar correctament, pot administrar les seves compres a la secció del seu compte",

    //Profile
    'PROFILE': "Perfil",
    'EMAIL': "Email",
    'EMAIL_REQUIRED': "Email és requerit",
    'EMAIL_NOT_VALID': "Email no és vàlid",
    'EMAIL_ALREADY_TAKEN': "Email ja acceptat o no vàlid",
    'BIRTHDAY': "Data de naixement",
    'MATURATIVE_AGE' : 'Edat madurativa',
    'BIRTHDAY_REQUIRED': "Eaniversari és requerit",
    'PRESCRIBER_TYPE': "Tipus d'prescriptor",
    'PRESCRIBER_TYPE_REQUIRED': "Es requereix el tipus de prescripció",
    'UPDATE_MY_DATA': "Actualitzar les meves dades",
    'CHANGE_PASSWORD': "Canviar clau d'acces",
    'PROFILE_UPDATE': "El teu perfil ha estat actualitzat",

    //Subscriptions
    'MANAGE_SUBSCRIPTIONS': "Administrar Subscripcions",
    'PRESCRIPTOR': "Prescriptor",
    'PATIENT': "Pacient",
    'PATIEN_EMAIL': "Ppacient Email",
    'STATUS': "Estat",
    'NUM_SUBSCRIPTIONS': "Número de subscripcions",
    'EXPIRATE_AT': "Expira el",
    'LINK_SUBSCRIPTION': "Vincular una nova subscripció",
    'UNLINK_SUBSCRIPTION': "Desvincular aquesta subscripció",
    'ADD_SUBSCRIPTION': "Afegir més subscripcions",
    'NO_SERS_YET': "No hi ha usuaris encara",
    'WOULD_LIKE_ADD_NEW_USER': "Vols afegir un nou usuari?",
    'active': 'Actiu',
    'inactive': 'Inactiu',
    'MODAL_CANCEL' : 'Cancel',
    'ADD_SUBSCRIPTION_TITLE' : 'Quants mesos de subscripció vol afegir?',
    'ADD_SUBSCRIPTION_CONTENT' : "Cada unitat de subscripció és equivalent a 1 mes. <br> Si vols que un usuari tingui 3 mesos de subscripció, afegiu 3. <br> Nota: cada unitat consumeix un subscriptor del total.",
    'ADD_SUBSCRIPTION_INPUT' : 'Número de subscripcions',
    'ADD_SUBSCRIPTION_SUCCESS' : "La suscripción s'ha afegit correctament.",
    'ADD_SUBSCRIPTION_BUTTON' : 'Afegir subscripció!',
    'REMOVE_SUBSCRIPTION_TITLE' : 'Segur que desitja eliminar aquesta subscrición a aquest usuari?',
    'REMOVE_SUBSCRIPTION_CONTENT' : 'En eliminar la subscripció, l\'usuari ja no tindrà accés.',
    'REMOVE_SUBSCRIPTION_BUTTON' : 'Eliminar!',
    'REMOVE_SUBSCRIPTION_SUCCESS' : "La subscripció s'ha eliminat correctament",
    'NO_USERS_YET' : "No té usuaris",
    'ENOUGH_SUBSCRIPTION_TITLE': 'No tens prou subscripcions',
    'ENOUGH_SUBSCRIPTION': 'No té més subscripcions per assignar. <br> Comprar més o avisa al seu administrador',
    'OK': 'Val',
    'LAST_ASSINGED': 'Darrera assignació',

    //Invoices
    'INVOICES': "Factures",
    'PRODUCT': "Producte",
    'AMOUNT': "Quantitat",
    'DATE': "Data",
    'DOWNLOAD_INVOICE': "Descarregar factura",
    'NO_PURCHASE_YET': "No hi ha compra encara",
    'PENDING_ORDERS': "Ordres pendents",
    'MAKE_PAYMENT_NOW': "Realitzar el pagament ara",
    'REMOVE_PENDING_ORDER': "Eliminar aquesta ordre pendent",
    'PAYMENTS': 'Abonaments',
    'PAYMENT': 'Abonament',

    //summary
    'MONTHLY_REVENUE': "Benefici Mensual",
    'VIEW_DETAILS': "Veure detalls",
    'PENDING_REVIEWS': "Ressenyes pendents",
    'NEW_CUSTOMERS': "Nous clients",

    //Products
    'ABBR': "Abbr",
    'PRICE': "Preu",
    'PRICE_MONTH': "Preu total",
    'ENROLLMENT': "Matricula",
    'PROMOTIONAL': "Promocional",
    'TYPE': "Tipus",
    'UNITS': "Unitats",
    'GAME': "Joc",

    //Variables
    'ABBREVIATION': "Abreviatura",
    'DESCRIPTION': "Descripció",
    'FLOAT': "Float",
    'INTEGER': "Integer",
    'BOOLEAN': "Boolean",
    'MULTIPLE': "Multiple",
    'REPETITIONS': "Repetitions",
    'MODIFY_FIXED': "Modificar fix",
    'MODIFY_RELATION': "Modificar Relació",
    'HARDNESS_INITIAL': "Duresa Inicial",
    'MODIFY_VARIABLE': "Modificar la variable",
    'STEPS': "Passos",
    'KEY': "Clau",
    'VALUE': "Valor",

    //Game
    'WEIGHT': "Pes",
    'ABILITY': "Habilitat",
    'PERCENTAGE': "Percentatge",
    'ADD': "Añadir",
    'VARIABLE': "Variable",
    'INCLUDED' : "Inclòs",
    'ONLY_GOLD': 'Només visible en PRO',
    'VISIBLE_AUTOMATIC':'NO visible en teràpia automàtica',

    //Entities
    'ID': "Id",
    'FINALIZED': "Finalitzat",
    'IDENTIFIER': "Identificador",
    'IP': "Ip",
    'METHOD': "Mètode",
    'UPDATED': "Actualitzat",
    'PAYPAL': "PayPal",
    'CREDIT_CARD': "Targeta de Crèdit",
    'WIRE_TRANSFER': "Transferència Bancària",
    'SUBSCRIPTION': "Subscripció",
    'CODE': "Codi",

    //User
    'user': "usuari",
    'Users': "Usuaris",
    'ENABLED': "Habilitat",
    'CREATED': "Creat",
    'ROLES': "Rols",
    'WORKERS': "Treballadors",
    'PATIENTS': "Pacients",
    'CIF': "Cif",
    'TRAINING_TIME_MIN': "Temps d'entrenament (min)",
    'TRAINING_TIME': "Temps d'entrenament",
    'TRAINING_DATE': "Data d'entrenament",
    'USER_TEST': "Usuari de Test",

    //Download
    'DOWNLOAD' : 'Descarregar',
    'TEXT_DOWNLOAD' : 'Descarrega aquí el teu gestor d\'aplicacions',
    'USER_VISUAL_WINDOWS': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/user_visual_guide_windows_ca.pdf',
    'USER_VISUAL_ANDROID': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/user_visual_guide_android_ca.pdf',
    'INSTALL_WINDOWS': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/sport_install_guide_windows_es.pdf',
    'INSTALL_ANDROID': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/sport_install_guide_windows_es.pdf',
    'USER_GUIDE_LABEL': 'Guia Visual',
    'INSTALL_LABEL': 'Guia Instal·lació',

    //Licences VR
    'LICENCES_GAME_VR' : 'Licencias GAME VR',

    //Events
    'EVENTS' : 'Esdeveniments',
    'LOCATION': 'Localizació',
    'LOCATION_MAP': 'Localizació en mapa google',
    'INTERESTED': 'Interessats',
    'IMAGE': 'Imatge',
    'PHONE': 'Telèfon',

    //ORDERS
    'purchase': "compra",
    'User': "Usuari",
    'Product': "Producte",
    'Status': "Estat",
    'Status Code': "Codi d'estat",
    'Method': "Mètode",

    // Promo
    'PROMO_UNAVAIABLE': 'La prova gratuïta ja a estat usada',
    'PROMO_REQUEST': 'Sol·licita la teva prova gratuïta',
    'PROMO_REGISTER' : 'Registre per prova gratuïta',
    'PROMO_CREATED_CHECK_YOUR_EMAIL' : 'Li hem enviat els passos a seguir per email.',
    'PROMO_PROBLEM_TITLE': "Se produjo un error",
    'PROMO_PROBLEM_TEXT': "S'han detectat errors i no pot continuar amb el registre per a la prova gratuïta, <br>si us plau enviï un correu electrònic a <a href=\"mailto:info@brainvt.com?Subject=Error pera a proba gratuïta\">info@brainvt.com</a> o trucant al 619 871 407"
};


/** WEBPACK FOOTER **
 ** ./js/languages/ca.js
 **/